import { LoadableAfterPaint } from '@confluence/loadable';

export const AdminKeyUpSell = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdminKeyUpSell" */ '../src/AdminKeyUpSell.tsx'))
			.AdminKeyUpSell,
});
